import React from 'react'
import PropTypes from 'prop-types'
import { StaticImage } from "gatsby-plugin-image"
import Anchor from '../shared/anchor';
import { LogoWrap } from './logo.stc'

const Logo = props => {
	return (
		<LogoWrap {...props}>
			<Anchor path="/">
				<StaticImage src="../../assets/img/logo.png" alt="Logo" className="dark-logo" />
				<StaticImage src="../../assets/img/white-logo.png" alt="Logo" className="white-logo" />
			</Anchor>
		</LogoWrap>
	)
}

Logo.propTypes = {
	transparentBG: PropTypes.bool
}

export default Logo
